module.exports = __webpack_public_path__ + "476f947263aad69c54709510e802d95c.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/fonts/bulorounded-regular.ttf
 ** module id = 9
 ** module chunks = 0
 **/